/**
 * Created by Joseph.Saliba on 2/3/16.
 */
namespace app.controllers {
    export class Factory {
        public static Create(t:{ new(...args: any[]): IController }):IController {
            return (...args: any[]) => new (Function.bind.apply(t, [t, ...args]))();
        }
    }
}